module.exports = {
  currently_no_todolists_visible: 'There are currently no todos here.',
  filters: {
    active: 'Active',
    done: 'Finished',
  },
  task_details: 'Task Details',
  tasks: 'Tasks',
  todolist: 'Task List',
  x_of_y_done: '{x}/{y} done',
  x_tasks: '{x} Tasks',
  need_to_upload_at_least_one_file: 'You have to upload at least one file in order to finish this todolist.',
  preview_comments_disabled: 'In the preview, the commenting feature is disabled.',
}
